import React from 'react'
import './PercentageSlider.scss'
import { BigNumber } from 'ethers'
import ReactSlider from 'react-slider'

interface IProps {
  label: string
  maxValue: BigNumber
  value: BigNumber
  onChange: (value: BigNumber) => void
  onAfterChange: (value: BigNumber) => void
}

export function PercentageSlider({ label, value, maxValue, onChange, onAfterChange }: IProps) {
  function formatSliderValue(percentage: number | number[]) {
    return maxValue.mul(percentage).div('100')
  }

  return (
    <div>
      <div className="percentage-slider--label">{label}</div>
      <ReactSlider
        value={getValueForSlider(value, maxValue)}
        onChange={(value) => onChange(formatSliderValue(value))}
        onAfterChange={(value) => onAfterChange(formatSliderValue(value))}
        className="percentage-slider"
        thumbClassName="percentage-slider--thumb"
        trackClassName="percentage-slider--track"
        renderThumb={(props, state) => <div {...props}>{state.valueNow}%</div>}
      />
    </div>
  )
}

function getValueForSlider(value: BigNumber, maxValue: BigNumber) {
  if (maxValue.isZero()) {
    return 0
  }
  const result = BigNumber.from(100).mul(value).div(maxValue)

  return result.gte('100') ? 100 : result.toNumber()
}
